import { gql } from '@apollo/client'

const INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE_FRAGMENT = gql`
  fragment IngredientCommonNegativeSynonymPhraseFragment on IngredientCommonNegativeSynonymPhrase {
    id
    phrase
    type
  }
`

export default INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE_FRAGMENT
